'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRedux = require('react-redux');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');

var _components = require('../../components');

var _containers = require('../../containers');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _constants = require('../../constants');
var _OMAccordion = require('../../components/OMComponents/OMAccordion/OMAccordion');var _OMAccordion2 = _interopRequireDefault(_OMAccordion);
var _TopBlock = require('./components/TopBlock');var _TopBlock2 = _interopRequireDefault(_TopBlock);
var _ModalFeedbackIncreaseLimits = require('../../components/FeedbackIncreaseLimits/ModalFeedbackIncreaseLimits');var _ModalFeedbackIncreaseLimits2 = _interopRequireDefault(_ModalFeedbackIncreaseLimits);
var _RealtorLandingPublishFormModal = require('../../containers/RealtorLandingPublishForm/RealtorLandingPublishFormModal');var _RealtorLandingPublishFormModal2 = _interopRequireDefault(_RealtorLandingPublishFormModal);

var _PaymentContainer = require('../../containers//PaymentContainer/PaymentContainer');var _PaymentContainer2 = _interopRequireDefault(_PaymentContainer);
var _upgradeRegularUserPackage = require('../../redux/modules/upgradeRegularUserPackage');
var _buyRocketPromotion = require('../../redux/modules/buyRocketPromotion');



var _payments = require('../../redux/modules/payments');
var _getManagePropertiesRowsPerPage = require('../../utils/getManagePropertiesRowsPerPage');var _getManagePropertiesRowsPerPage2 = _interopRequireDefault(_getManagePropertiesRowsPerPage);

var _ManagePropertiesForAgent = require('./ManagePropertiesForAgent.scss');var _ManagePropertiesForAgent2 = _interopRequireDefault(_ManagePropertiesForAgent);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var ManagePropertiesForAgent = function (_Component) {_inherits(ManagePropertiesForAgent, _Component);function ManagePropertiesForAgent() {var _temp, _this, _ret;_classCallCheck(this, ManagePropertiesForAgent);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      makeAllSelected: false,
      mobileFiltersIsOpen: false,
      currentSorting: '',
      selectedProperties: [],
      selectedColumns: [].concat(_constants.columnsDefaultState),
      filtersData: {},
      openModal: false,
      isContactModalOpen: false,
      showTooltip: false,
      sortOrder: '' }, _this.






    getFilteredColumns = function (name) {
      if (typeof _constants.storage.value !== 'undefined') {
        try {
          var selectedColumns = JSON.parse(_constants.storage.value.getItem(name));
          if (selectedColumns instanceof Array && selectedColumns.length) {
            var filteredColumns = _this.state.selectedColumns.filter(function (col) {return selectedColumns.includes(col.name);});
            _this.setState({ selectedColumns: filteredColumns });
          } else {
            _this.setState(function (state) {return Object.assign({},
              state, {
                selectedColumns: state.selectedColumns.
                filter(function (col) {return col.name !== 'favouritesCount';}) });});

          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from storage.value');
        }
      }
    }, _this.

    getSelectedProperties = function () {return (
        _this.state.selectedProperties.map(function (_ref) {var id = _ref.id;return (
            _this.props.properties.find(function (property) {return property.id === id;}) ||
            _this.state.selectedProperties.find(function (_ref2) {var property = _ref2.property;return property.id === id;}));}));}, _this.


    getRoute = function (route) {return function () {return _reactRouter.browserHistory.push(route);};}, _this.
    getDropdownPropertyRef = function (ref) {_this.dropdownProperty = ref;}, _this.

    updateSelectedProperties = function (ids) {
      var newState = {};
      newState.selectedProperties = ids;
      if (ids.length === _this.props.properties.length) {
        newState.makeAllSelected = true;
      } else if (_this.state.makeAllSelected) {
        newState.makeAllSelected = false;
      }

      _this.setState(Object.assign({}, newState));
    }, _this.

    updateSelectedColumns = function (value) {
      _this.setState({ selectedColumns: value });

      var filteredColumns = value.map(function (_ref3) {var name = _ref3.name;return name;});
      var serializedVal = JSON.stringify(filteredColumns);
      if (typeof _constants.storage.value !== 'undefined') {
        _constants.storage.value.setItem('filteredColumns', serializedVal);
      }
    }, _this.

    selectAllHandler = function () {
      var newState = {};
      if (_this.state.selectedProperties.length !== _this.props.properties.length) {
        newState = {
          selectedProperties: _this.props.properties.map(function (_ref4) {var id = _ref4.id,is_active = _ref4.is_active,address = _ref4.address,contacts = _ref4.contacts;return {
              id: id,
              isActive: is_active,
              isForeignProperty: (0, _checkIsForeignAddress2.default)(address),
              contacts: contacts };}),

          makeAllSelected: true };

      } else if (_this.state.makeAllSelected) {
        newState = {
          selectedProperties: [],
          makeAllSelected: false };

      }
      _this.setState(Object.assign({}, newState));
    }, _this.

    checkPropertyConditions = function (property) {
      if (!property) return true;var


      move_to_top =




      property.move_to_top,is_active = property.is_active,is_autojump_enabled = property.is_autojump_enabled,is_promoted = property.is_promoted,is_top_promoted = property.is_top_promoted;

      return property &&
      move_to_top &&
      is_active &&
      !is_autojump_enabled &&
      !is_promoted &&
      !is_top_promoted;
    }, _this.

    updatePropertyActivity = function (_ref5) {var active = _ref5.active;return _this.props.updatePropertyActivity({
        properties: _this.state.selectedProperties,
        active: active });}, _this.


    filterSelectedOptions = function () {return _this.getSelectedProperties().filter(_this.checkPropertyConditions);}, _this.

    sortUserProperties = function (evt, field) {
      evt.preventDefault();
      var isSameSortField = _this.state.currentSorting === field;
      var nextSortOrder = _this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC';

      _this.setState({ currentSorting: field, sortOrder: isSameSortField ? nextSortOrder : 'ASC' });
    }, _this.

    paginationUserProperties = function () {
      var filtersData = {
        token: (0, _get2.default)(_this.props, 'userData.access_token'),
        data: Object.assign({},
        !_this.state.filtersData.data ? { is_active: true } : {},
        _this.state.filtersData.data, {
          $skip: _this.props.currentPaginationStep - 1,
          $limit: (0, _getManagePropertiesRowsPerPage2.default)(),
          language: _this.props.locale }),

        sort_by: _this.state.currentSorting,
        sort_order: _this.state.sortOrder };



      _this.props.loadUserProperties(filtersData);
    }, _this.

    loadUserProperties = function (filtersData) {
      _this.setState({ filtersData: filtersData }, function () {
        _this.props.loadUserProperties(_this.state.filtersData);
      });
    }, _this.

    exportProperties = function () {var
      locale = _this.props.locale;var
      filtersData = _this.state.filtersData;
      var token = (0, _get2.default)(_this.props, 'userData.access_token');

      var requestData = Object.keys(filtersData).length ? Object.assign({},
      filtersData, { token: token }) :
      { token: token, data: { is_active: true } };

      _this.props.exportUserProperties(Object.assign({}, requestData, { data: Object.assign({}, requestData.data, { locale: locale }) }));
    }, _this.

    addPropertiesToTopInBulk = function () {
      var renderShareButton = _this.state.selectedProperties.length === 1;
      _this.props.shouldRenderShareButton(renderShareButton);
      return !_this.props.disabledPromotionAction &&
      _this.filterSelectedOptions().map(function (_ref6) {var id = _ref6.id;return _this.props.movePropertyToTop(id, renderShareButton);});
    }, _this.

    isMoveToTopPossible = function () {return _this.getSelectedProperties().some(_this.checkPropertyConditions);}, _this.

    openFilters = function () {return _this.setState({ mobileFiltersIsOpen: true });}, _this.
    closeFilters = function () {return _this.setState({ mobileFiltersIsOpen: false });}, _this.

    closeModal = function () {return _this.setState({ openModal: false });}, _this.
    openModal = function () {return _this.setState({ openModal: true });}, _this.

    closeFormModal = function () {return _this.setState({ isContactModalOpen: false });}, _this.
    openFormModal = function () {return _this.setState({ isContactModalOpen: true });}, _this.

    handleMouseEnter = function () {_this.setState({ showTooltip: true });}, _this.
    handleMouseLeave = function () {_this.setState({ showTooltip: false });}, _this.

    redirectContactUsRealtor = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/contact_us_realtor'));}, _this.

    openDropdownProperty = function () {return _this.dropdownProperty && _this.dropdownProperty.click();}, _this.

    renderPackagePromotion = function () {return (
        _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.packagePromotionWrapper },











          _react2.default.createElement(_components.PackagePromotion, {
            translate: _this.props.translate('managePage'),
            packageName: 'highlight',
            iconName: 'promoted',
            promotions: (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.promotion', {}),
            packageStyle: _ManagePropertiesForAgent2.default.packagePromotion,
            labelStyle: _ManagePropertiesForAgent2.default.packagePromotionLabel,
            counter: _ManagePropertiesForAgent2.default.counter,
            isRtl: _this.props.isRtl,
            userProperties: _this.props.userProperties }),


          _react2.default.createElement(_components.PackagePromotion, {
            translate: _this.props.translate('managePage'),
            packageName: 'top_promotion',
            iconName: 'top-promotion',
            promotions: (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.top_promotion', {}),
            packageStyle: _ManagePropertiesForAgent2.default.packagePromotion,
            labelStyle: _ManagePropertiesForAgent2.default.packagePromotionLabel,
            counter: _ManagePropertiesForAgent2.default.counter,
            isRtl: _this.props.isRtl,
            userProperties: _this.props.userProperties })));}, _this.




    renderFilters = function () {
      var virtualNumbers = (0, _get2.default)(_this.props, 'userData.virtual_numbers');

      var filters =
      _react2.default.createElement(_components.ManagePropertiesFilters, {
        setCurrentPaginationStep: _this.props.setCurrentPaginationStep,
        userData: _this.props.userData,
        virtualNumbers: virtualNumbers,
        propertyTypes: _this.props.propertyTypes,
        sortedPropertyTypes: _this.props.sortedPropertyTypes,
        translate: _this.props.translate,
        locale: _this.props.locale,
        loadUserProperties: _this.loadUserProperties,
        token: (0, _get2.default)(_this.props, 'userData.access_token'),
        updateSelectedColumns: _this.updateSelectedColumns,
        selectedColumns: _this.state.selectedColumns,
        isMobile: _this.props.isMobile,
        currentSorting: _this.state.currentSorting,
        sortOrder: _this.state.sortOrder,
        staff: (0, _get2.default)(_this.props, 'userProperties.meta.staff', []) });



      return _this.props.isMobile ?

      _react2.default.createElement(_OMAccordion2.default, {
          accordionOpen: _this.state.mobileFiltersIsOpen,
          onOpen: _this.openFilters,
          onClose: _this.closeFilters,
          titleValue:
          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.filtersTitle },
            _react2.default.createElement('span', { className: _ManagePropertiesForAgent2.default.title }, _this.props.translate('managePage', 'filters')),
            _react2.default.createElement('span', { className: 'icon icon-bar' })),


          className: _ManagePropertiesForAgent2.default.filtersAccordion },

        filters) :


      filters;
    }, _this.

    renderExportButton = function () {return (
        _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.exportButton, onClick: _this.exportProperties },
          _react2.default.createElement('span', { className: _ManagePropertiesForAgent2.default.exportIcon }, _react2.default.createElement('span', { className: 'icon icon-excel' })),
          _react2.default.createElement('span', null, _this.props.translate('managePage', 'export'))));}, _this.



    renderPropertyActivity = function () {var _this$props =



      _this.props,translate = _this$props.translate,foreign = _this$props.userData.publish_permissions.foreign;

      var isShowTooltip = _this.state.selectedProperties.some(function (_ref7) {var isActive = _ref7.isActive,isForeignProperty = _ref7.isForeignProperty;return (
          !foreign && !isActive && isForeignProperty);});

      var propertyActivity = function propertyActivity() {return _this.updatePropertyActivity({ active: true });};

      return (
        _react2.default.createElement('div', {
            className: _ManagePropertiesForAgent2.default.activeContainer,
            onClick: !isShowTooltip && propertyActivity,
            onMouseEnter: isShowTooltip && _this.handleMouseEnter,
            onMouseLeave: isShowTooltip && _this.handleMouseLeave },

          _react2.default.createElement('span', { className: 'icon icon-active' },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' })),

          _react2.default.createElement('span', null, _this.props.translate('managePage', 'makeActive')),
          _this.state.showTooltip && _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.tooltip },
            translate('managePage', 'tooltip'))));



    }, _this.

    renderDesktopControls = function () {var _cx;
      if (_this.props.isMobile) {return null;}var _this$props2 =




      _this.props,translate = _this$props2.translate,_this$props2$userData = _this$props2.userData.publish_permissions,regular = _this$props2$userData.regular,foreign = _this$props2$userData.foreign;
      var isMoveToTopPossible = _this.isMoveToTopPossible();
      var propertiesToTopCounter = _this.filterSelectedOptions().length;
      var selectedPropertiesCounter = _this.state.selectedProperties.length;

      return (
        _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.headerBlock },
          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.manageActions },
            _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.selectAll },
              _react2.default.createElement(_components.OMCheckbox, {
                label: translate('managePage', 'selectAll'),
                field: {
                  value: _this.state.makeAllSelected,
                  checked: _this.state.makeAllSelected,
                  onChange: _this.selectAllHandler } })),




            _this.state.selectedProperties.length ?
            _react2.default.createElement('div', { onClick: function onClick() {return _this.updatePropertyActivity({ active: false });} },
              _react2.default.createElement('span', { className: 'icon icon-inactive' },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              translate('managePage', 'deactivate')) :

            null,

            _this.state.selectedProperties.length ? _this.renderPropertyActivity() : null,

            _this.state.selectedProperties.length ?
            _react2.default.createElement('div', {
                className: (0, _classnames2.default)((_cx = {}, _cx[_ManagePropertiesForAgent2.default.inactive] = !isMoveToTopPossible, _cx)),
                onClick: _this.addPropertiesToTopInBulk },

              _react2.default.createElement('span', { className: (0, _classnames2.default)(
                  isMoveToTopPossible ?
                  'icon icon-jump-to-top' :
                  'icon icon-jump-to-top-disabled') },


                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              _react2.default.createElement('span', null,
                translate('managePage', 'jumpToTop') + ' ',
                !!propertiesToTopCounter &&
                _react2.default.createElement('sup', null,
                  _react2.default.createElement('span', { className: _ManagePropertiesForAgent2.default.moveToTopCounter }, propertiesToTopCounter),
                  _react2.default.createElement('span', null, '/', selectedPropertiesCounter)))) :





            null),


          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.publishBlock },
            foreign && !regular &&
            _react2.default.createElement(_components.OMPublishButton, {
              publishProperty: _this.props.publishForeignProperty,
              translate: translate,
              isForein: true }),


            !foreign && regular &&
            _react2.default.createElement(_components.OMPublishButton, {
              publishProperty: _this.props.publishProperty,
              translate: translate }),


            foreign && regular &&
            _react2.default.createElement(_components.MenuDropdownProperty, {
              triggerIds: ['publishPropertyButtonTitle', 'publishPropertyButton'],
              innerRef: _this.getDropdownPropertyRef,
              translate: _this.props.translate,
              onClick: _this.openDropdownProperty,
              getRoute: _this.getRoute,
              locale: _this.props.locale,
              publishForeignProperty: _this.props.publishForeignProperty,
              isManageProperties: true }),


            _this.renderExportButton())));



    }, _this.

    renderContactFormModal = function () {return (
        _react2.default.createElement(_components.Modal, {
            className: 'publishFormContactUsModal',
            isOpen: _this.state.isContactModalOpen,
            onRequestClose: _this.closeFormModal,
            isRtl: _this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_RealtorLandingPublishFormModal2.default, {
            inModal: true,
            formModalIsOpen: _this.state.isContactModalOpen,
            handleRequest: _this.closeFormModal })));}, _this.




    renderMobileControls = function () {var _cx2;
      if (!_this.props.isMobile) {return null;}var _this$props3 =




      _this.props,translate = _this$props3.translate,foreign = _this$props3.userData.publish_permissions.foreign;
      var isMoveToTopPossible = _this.isMoveToTopPossible();
      var propertiesToTopCounter = _this.filterSelectedOptions().length;
      var selectedPropertiesCounter = _this.state.selectedProperties.length;
      var isShowModal = _this.state.selectedProperties.some(function (_ref8) {var isActive = _ref8.isActive,isForeignProperty = _ref8.isForeignProperty;return (
          !foreign && !isActive && isForeignProperty);});

      var propertyActivity = function propertyActivity() {
        if (isShowModal) {
          return _this.props.openMessageModal({ message:
            _react2.default.createElement('div', null, _this.props.translate('managePage', 'tooltip')) });

        }

        return _this.updatePropertyActivity({ active: true });
      };

      return (
        _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.mobileHeaderBlock },
          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.selectAll },
            _react2.default.createElement(_components.OMCheckbox, {
              label: translate('managePage', 'selectAll'),
              className: 'customCheckBox',
              field: {
                value: _this.state.makeAllSelected,
                checked: _this.state.makeAllSelected,
                onChange: _this.selectAllHandler } }),


            _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.selectedCount },
              selectedPropertiesCounter || null,
              (selectedPropertiesCounter || null) &&
              _react2.default.createElement('span', null, '\xA0', translate('managePage', 'selected')))),




          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.mobileManageActions },
            _this.state.selectedProperties.length ?
            _react2.default.createElement('div', { onClick: function onClick() {return _this.updatePropertyActivity({ active: false });} },
              _react2.default.createElement('span', { className: 'icon icon-inactive' },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              _react2.default.createElement('span', null, '\xA0\xA0', translate('managePage', 'deactivate'), '\xA0\xA0')) :

            null,

            _this.state.selectedProperties.length ?
            _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.activeContainer, onClick: propertyActivity },
              _react2.default.createElement('span', { className: 'icon icon-active' },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              _react2.default.createElement('span', null, '\xA0\xA0', translate('managePage', 'makeActive'), '\xA0\xA0')) :

            null,

            _this.state.selectedProperties.length ?
            _react2.default.createElement('div', {
                className: (0, _classnames2.default)((_cx2 = {}, _cx2[_ManagePropertiesForAgent2.default.inactive] = !isMoveToTopPossible, _cx2)),
                onClick: _this.addPropertiesToTopInBulk },

              _react2.default.createElement('span', { className: (0, _classnames2.default)(
                  isMoveToTopPossible ?
                  'icon icon-jump-to-top' :
                  'icon icon-jump-to-top-disabled') },


                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' })),

              _react2.default.createElement('span', null, '\xA0\xA0',
                translate('managePage', 'jumpToTop') + ' ',
                !!propertiesToTopCounter &&
                _react2.default.createElement('sup', null,
                  _react2.default.createElement('span', { className: _ManagePropertiesForAgent2.default.moveToTopCounter }, propertiesToTopCounter),
                  _react2.default.createElement('span', null, '/', selectedPropertiesCounter)), '\xA0\xA0')) :




            null)));




    }, _temp), _possibleConstructorReturn(_this, _ret);}ManagePropertiesForAgent.prototype.componentDidMount = function componentDidMount() {this.getFilteredColumns('filteredColumns');};ManagePropertiesForAgent.prototype.

  render = function render() {var _props =








    this.props,isRtl = _props.isRtl,isMobile = _props.isMobile,translate = _props.translate,userProperties = _props.userProperties,propertiesAnalytics = _props.propertiesAnalytics,_props$userData$publi = _props.userData.publish_permissions,regular = _props$userData$publi.regular,foreign = _props$userData$publi.foreign,isNative = _props.isNative;
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.headParts },
          _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.topBlockWrapper },
            _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.title }, translate('managePage', 'package')),
            _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.topBlock },
              userProperties.data && regular &&
              _react2.default.createElement(_TopBlock2.default, {
                getProperties: 'user_properties',
                userProperties: userProperties,
                translate: translate,
                title: foreign && translate('managePage', 'israelProperties'),
                clickPackageUpdate: this.openFormModal }),


              userProperties.data && foreign &&
              _react2.default.createElement(_TopBlock2.default, {
                getProperties: 'user_foreign_properties',
                userProperties: userProperties,
                translate: translate,
                title: translate('managePage', 'foreignProperties'),
                clickPackageUpdate: this.openModal }),


              userProperties.data && this.renderPackagePromotion())),



          this.renderFilters(),
          this.renderDesktopControls(),
          this.renderMobileControls()),


        isMobile && _react2.default.createElement('div', { className: _ManagePropertiesForAgent2.default.exportButtonWrap }, this.renderExportButton()),


        !!this.props.properties.length &&
        _react2.default.createElement('div', null,
          _react2.default.createElement(_containers.PropertiesTable, {
            paginationUserProperties: this.paginationUserProperties,
            buyRocketPromotion: this.props.buyRocketPromotion,
            openBuyModalRocketModal: this.props.openBuyModalRocketModal,
            hideBuyModalRocketModal: this.props.hideBuyModalRocketModal,
            openDetailsToInvoiceForm: this.props.openDetailsToInvoiceForm,
            changeSelectedPayment: this.props.changeSelectedPayment,
            isPublishPermissionsForeign: foreign,
            translate: translate,
            isMobile: isMobile,
            isRtl: isRtl,
            properties: this.props.properties,
            locale: this.props.locale,
            editProperty: this.props.editProperty,
            openDetailsPopup: this.props.openDetailsPopup,
            updatePropertyActivity: this.props.updatePropertyActivity,
            updateTopPromotionActivity: this.props.updateTopPromotionActivity,
            updatePropertyHighlighting: this.props.updatePropertyHighlighting,
            openContactUsModal: this.props.openContactUsModal,
            selectedProperties: this.state.selectedProperties,
            updateSelectedProperties: this.updateSelectedProperties,
            propertiesAnalytics: propertiesAnalytics,
            performAnalyticsQueries: this.props.performAnalyticsQueries,
            movePropertyToTop: this.props.movePropertyToTop,
            openChartOfViews: this.props.openChartOfViews,
            setCurrentPaginationStep: this.props.setCurrentPaginationStep,
            currentPaginationStep: this.props.currentPaginationStep,
            loadSinglePropertyAnalytics: this.props.loadSinglePropertyAnalytics,
            updateAutoJumpToTopActivity: this.props.updateAutoJumpToTopActivity,
            propertiesCount: (0, _get2.default)(this.props, 'userProperties.meta.count'),
            jumpPromotion: (0, _get2.default)(this.props, 'userProperties.data.meta.user_properties.jump_promotion'),
            promotion: (0, _get2.default)(this.props, 'userProperties.data.meta.user_properties.promotion'),
            top_promotion: (0, _get2.default)(this.props, 'userProperties.data.meta.user_properties.top_promotion'),
            selectedColumns: this.state.selectedColumns,
            closeMobileFilters: this.closeFilters,
            mobileFiltersIsOpen: this.state.mobileFiltersIsOpen,
            currentSorting: this.state.currentSorting,
            sortOrder: this.state.sortOrder,
            sortUserProperties: this.sortUserProperties,
            openMessageModal: this.props.openMessageModal,
            exportProperties: this.exportProperties,
            disabledPromotionAction: this.props.disabledPromotionAction,
            isNative: isNative }),

          _react2.default.createElement(_containers.ChartOfViews, {
            translate: translate,
            propertiesAnalytics: propertiesAnalytics,
            onRequestClose: this.props.closeChartOfViews,
            isRtl: this.props.isRtl })),




        _react2.default.createElement(_ModalFeedbackIncreaseLimits2.default, { closeModal: this.closeModal, openModal: this.state.openModal, isPackageUpdate: true }),
        this.renderContactFormModal()));


  };return ManagePropertiesForAgent;}(_react.Component);


ManagePropertiesForAgent.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  properties: _propTypes2.default.array,
  propertyTypes: _propTypes2.default.array,
  sortedPropertyTypes: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  editProperty: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  updatePropertyActivity: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  openContactUsModal: _propTypes2.default.func,
  publishProperty: _propTypes2.default.func,
  movePropertyToTop: _propTypes2.default.func,
  userProperties: _propTypes2.default.object,
  propertiesAnalytics: _propTypes2.default.object,
  loadUserProperties: _propTypes2.default.func,
  exportUserProperties: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  openChartOfViews: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  closeChartOfViews: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  performAnalyticsQueries: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  currentPaginationStep: _propTypes2.default.number,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  actionDone: _propTypes2.default.bool,
  shouldRenderShareButton: _propTypes2.default.func,
  publishForeignProperty: _propTypes2.default.func,
  disabledPromotionAction: _propTypes2.default.bool,
  buyRocketPromotion: _propTypes2.default.object,
  openBuyModalRocketModal: _propTypes2.default.func,
  hideBuyModalRocketModal: _propTypes2.default.func,
  changeSelectedPayment: _propTypes2.default.func,
  openDetailsToInvoiceForm: _propTypes2.default.func,
  isNative: _propTypes2.default.bool };


var mapDispatchToProps = {
  openUpgradePackageModal: _upgradeRegularUserPackage.openUpgradePackageModal,
  openBuyModalRocketModal: _buyRocketPromotion.openBuyModalRocketModal,
  hideBuyModalRocketModal: _buyRocketPromotion.hideBuyModalRocketModal,
  changeSelectedPayment: _payments.changeSelectedPayment };


var mapStateToProps = function mapStateToProps(state) {return {
    modalShareId: state.shareModal.id,
    buyRocketPromotion: state.buyRocketPromotion };};exports.default =



(0, _PaymentContainer2.default)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManagePropertiesForAgent));module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ManagePropertiesForAgent/ManagePropertiesForAgent.js
// module id = 2999
// module chunks = 0